import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useRosaResultContext } from '../context';
import { Title } from '@/components/Typography';
import * as S from './styles';

export function FinalScore() {
	const {
		rosaResult: {
			scores: { final_score }
		}
	} = useRosaResultContext();

	const colors = [
		'rgba(44, 200, 82, 1)',
		'rgba(248, 214, 39, 1)',
		'rgba(248, 214, 39, 1)',
		'rgba(248, 214, 39, 1)',
		'rgba(247, 138, 56, 1)',
		'rgba(231, 65, 80, 1)',
		'rgba(231, 65, 80, 1)',
		'rgba(231, 65, 80, 1)',
		'rgba(155, 84, 226, 1)',
		'rgba(155, 84, 226, 1)'
	];

	function isFinalScore(score: number) {
		return score === final_score;
	}

	function borderRadius(index: number) {
		if (index === 0) {
			return '0.5rem 0 0 0.5rem';
		}
		if (index === 9) {
			return '0 0.5rem 0.5rem 0';
		}
		return '0';
	}

	return (
		<Row gutter={[0, 10]}>
			<Col span={24}>
				<Title level={5}>{I18n.get('Final score ROSA')}</Title>
			</Col>
			{[...Array(10).keys()].map((score, index) => (
				<S.StyledCol key={score} xs={2}>
					<S.ScoreComponent
						style={{
							backgroundColor: isFinalScore(score + 1)
								? colors[score]
								: colors[score].replace('1)', '0.1)'),
							borderColor: colors[score],
							borderRadius: borderRadius(index)
						}}
						isFinalScore={isFinalScore(score + 1)}
					>
						<h2 style={{ color: isFinalScore(score + 1) ? '#fff' : colors[score] }}>
							<strong>{score + 1}</strong>
						</h2>
					</S.ScoreComponent>
				</S.StyledCol>
			))}
		</Row>
	);
}
